import ActionButton from '../../../components/actionButton/ActionButton';
import { ApplicationContext } from '../../../framework/framework/shared/ApplicationContext';
import classes from '../../../framework/framework/tools/classes';
import TextInput from '../../../components/textInput/TextInput';
import { IRegisterData } from '../../../services/accountService/IRegisterData';
import * as style from './style.css';
import { AccountService } from '../../../services/accountService/AccountService';
import ErrorsComp from '../../../components/errors/ErrorsComp';
import LoginForm from '../login/LoginForm';
import React = require('react');

interface IProps {
    appCtx: ApplicationContext;
    id?: string;
}

interface IState {
    userData: IRegisterData;
    registered: boolean;

    registerInProgress: boolean;
    activated: number;
}

export default class RegisterPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            userData: {
                name: '',
                surname: '',
                email: '',
                phone: '',
                login: '',
                password: '',
                password2: '',
                errors: {}
            } as IRegisterData,
            registered: false,
            registerInProgress: false,
            activated: 0
        };
    }

    componentDidMount() {
        if (this.props.id && this.props.id.length > 10) {
            this.accountService.activate(this.props.id, () => this.setState({ activated: 1 }), () => this.setState({ activated: -1 }));
        }
    }

    accountService = AccountService.Instance();

    render() {
        if (this.state == null || this.state.userData == null) {
            return <></>;
        }
        let partial = null;
        if (this.props.id) {
            partial = this.getRegisteredForm();
        }

        partial = partial || this.getUserForm();

        return (
            <div className={style.formWrapper}>

                <div className={classes(style.leftPanel, style.withBorder)}>
                    {partial}
                </div>
                <div className={classes(style.info, style.withBorder)}>
                    <LoginForm
                        accountService= {this.accountService}
                        onSuccess={() => this.onLoginSuccess()}
                    />
                </div>
            </div>
        );
    }

    getUserForm() {
        const userData = this.state.userData;
        return (<form>

            <div className={style.formContainer}>

                <TextInput
                    key={1}
                    value={userData.login}
                    onChange={(s: string) => this.onValueChange('login', s)}
                    onKeyDown={() => { }}
                    errors={userData.errors.login}
                    placeholder="nazwa wyświetlana (wymagane)" />

                <TextInput
                    key={2}
                    value={userData.name}
                    onChange={(s: string) => this.onValueChange('name', s)}
                    onKeyDown={() => { }}
                    placeholder="imię" />

                <TextInput
                    key={3}
                    value={userData.surname}
                    onChange={(s: string) => this.onValueChange('surname', s)}
                    onKeyDown={() => { }}
                    placeholder="nazwisko" />

                <TextInput
                    key={4}
                    value={userData.email}
                    onChange={(s: string) => this.onValueChange('email', s)}
                    onKeyDown={() => { }}
                    errors={userData.errors.email}
                    placeholder="adres email (wymagane)" />

                <TextInput
                    key={5}
                    value={userData.phone}
                    onChange={(s: string) => this.onValueChange('phone', s)}
                    onKeyDown={() => { }}
                    placeholder="telefon" />

                <TextInput
                    key={6}
                    value={userData.password}
                    onChange={(s: string) => this.onValueChange('password', s)}
                    onKeyDown={() => { }}
                    placeholder={'hasło (wymagane)'}
                    autoComplete={'new-password'}
                    errors={userData.errors.password}
                    type='password' />

                <TextInput
                    key={7}
                    value={userData.password2}
                    onChange={(s: string) => this.onValueChange('password2', s)}
                    onKeyDown={() => { }}
                    autoComplete={'new-password'}
                    placeholder={'potwierdzenie (wymagane)'}
                    errors={userData.errors.password2}
                    type='password' />

                <div className={style.buttonWrapper} key={'button'}>
                    <ActionButton label={'Rejestracja'}
                        onClick={() => this.onConfirmClick()}
                        disabled={this.state.registerInProgress} />

                    <ErrorsComp errors={userData.errors.general} />
                </div>

                {this.state.registered &&
                    <div key={'thanks'} className={style.message}>
                        {`Twoje konto zostało zarejestrowane. Na podany adres email wysłaliśmy wiadomość z linkiem w celu aktywacji konta.
                Konto zostanie aktywowane po kliknięciu w przesłany link. Dziękujemy.`}
                    </div>}
            </div>
        </form>);
    }

    onLoginSuccess(): any {
        window.location.href = this.props.appCtx.buildUrl('');
    }

    onValueChange(prop: string, s: string): void {
        const userData = this.state.userData;
        if (userData.errors[prop]) {
            userData.errors[prop] = [];
        }
        userData[prop] = s;
        this.setState({ userData: userData });
    }

    onConfirmClick() {
        this.setState({ registerInProgress: true, registered: false }, () => {
            this.accountService.register(this.state.userData,
                () => this.setState({ registered: true, registerInProgress: false, userData: { email: '', password: '', password2: '', login: '', name: '', surname: '', phone: '', errors: {} } }),
                (errors) => {
                    const userData = this.state.userData;
                    userData.errors = errors;
                    this.setState({ userData: userData, registerInProgress: false });
                }
            );
        });
    }

    getRegisteredForm(): any {
        if (this.state.activated === 1) {
            return (<div className={style.register} >
                Konto zostało aktywowane
                <ActionButton label={'Strona główna'}
                    onClick={() => { window.location.href = this.props.appCtx.buildUrl('/'); }}
                    disabled={false} />
            </div>);
        }
        if (this.state.activated === -1) {
            return (<div className={style.register} >

                {'Błąd aktywacji konta'}
                <ActionButton label={'Rejestracja'}
                    onClick={() => { window.location.href = this.props.appCtx.buildUrl('/rejestracja'); }}
                    disabled={false} />

            </div>);
        }
        return <>Aktywuję konto...</>;
    }
}
